import React, { useState, useEffect, useRef } from 'react';

const TermAutocompleteTextArea = ({ value, termsList, onUpdate, disabled, style, placeholder, insertField = 'description', onSelectFull }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Extraer la última línea para la búsqueda
    const lines = (value || '').split('\n');
    const lastLine = lines.length > 0 ? lines[lines.length - 1] : '';

    const filteredOptions = termsList.filter(item => {
        const term = lastLine.toLowerCase().trim();
        if (!term) return false;
        return (item.code || '').toLowerCase().includes(term) || (item.description || '').toLowerCase().includes(term);
    }).slice(0, 30);

    useEffect(() => {
        setSelectedIndex(-1);
    }, [lastLine]);

    const handleKeyDown = (e) => {
        if (!isOpen || filteredOptions.length === 0) return;
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setSelectedIndex(prev => (prev < filteredOptions.length - 1 ? prev + 1 : prev));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setSelectedIndex(prev => (prev > 0 ? prev - 1 : prev));
        } else if (e.key === 'Enter') {
            if (selectedIndex >= 0 && selectedIndex < filteredOptions.length) {
                e.preventDefault();
                handleSelect(filteredOptions[selectedIndex]);
            }
        }
    };

    const handleSelect = (item) => {
        const newLines = [...lines];
        if (insertField === 'full') {
            newLines[newLines.length - 1] = item.code ? `${item.code}: ${item.description}` : item.description;
        } else {
            newLines[newLines.length - 1] = item[insertField] || item.description;
        }
        onUpdate(newLines.join('\n').toUpperCase());
        if (onSelectFull) {
            onSelectFull(item);
        }
        setIsOpen(false);
        setSelectedIndex(-1);
    };

    return (
        <div ref={wrapperRef} style={{ position: 'relative', width: '100%', height: '100%' }}>
            <textarea
                style={{ ...style, resize: 'none' }}
                value={value || ''}
                onChange={(e) => {
                    onUpdate(e.target.value.toUpperCase());
                    setIsOpen(true);
                }}
                onFocus={() => setIsOpen(true)}
                onKeyDown={handleKeyDown}
                disabled={disabled}
                placeholder={placeholder}
            />
            {isOpen && !disabled && lastLine.trim() && filteredOptions.length > 0 && (
                <ul style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    minWidth: '400px',
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    zIndex: 9999,
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    textAlign: 'left'
                }}>
                    {filteredOptions.map((item, index) => (
                        <li 
                            key={item.id || item.code || Math.random()}
                            style={{ padding: '8px', cursor: 'pointer', borderBottom: '1px solid #eee', fontSize: '11px', fontFamily: 'Arial', lineHeight: '1.2', backgroundColor: selectedIndex === index ? '#e6f2ff' : 'transparent' }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                handleSelect(item);
                            }}
                            onMouseEnter={() => setSelectedIndex(index)}
                        >
                            {item.code && <strong style={{ color: '#b87a00', display: 'block', marginBottom: '2px' }}>{item.code}</strong>}
                            <span style={{ color: '#555' }}>
                                {item.description && item.description.length > 150 ? item.description.substring(0, 150) + '...' : item.description}
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default TermAutocompleteTextArea;
